import * as React from 'react';
import { useContext } from 'react';

import type { S12nTargetDegreesFragment as TargetDegrees } from 'bundles/page-config-common/queries/__generated__/GetS12nTargetDegreesQuery';

// Holds map of s12n ID -> target degrees.
const S12nTargetDegreesContext = React.createContext<{ [key: string]: TargetDegrees } | undefined>(undefined);

export const useS12nTargetDegrees = () => {
  return useContext(S12nTargetDegreesContext);
};

export default S12nTargetDegreesContext;
